export default __webpack_public_path__ + "static/media/1850.ba6bd088.png";